import { User } from "./user";
import { EntryLine } from "./entry-line";

export class Entry {
    id:number = 0;
    reference:string = '';
    doc_date:Date = new Date();
    entry_date:Date = new Date();
    description:string = '';
    status:string = 'Abierto';
    user_id:number = 0;
    user:User = new User();
    lines:EntryLine[] = [];
    authorized:boolean = false;
    authorized_by:User = null;
}